import LegalPage from './LegalPage'
import { TERMS_OF_SERVICE } from './legal'

export default function TermsOfServicePage() {
  return <LegalPage {...TERMS_OF_SERVICE} />
}
